import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hpc_checkbox_seleted",
  "use": "icon-hpc_checkbox_seleted-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-hpc_checkbox_seleted\">\n<rect width=\"16\" height=\"16\" rx=\"2\" fill=\"#4BD214\" />\n<path d=\"M5.95006 11.5097L3.12164 8.68125C2.9341 8.49371 2.82874 8.23936 2.82874 7.97414C2.82874 7.70893 2.9341 7.45457 3.12164 7.26704C3.30917 7.0795 3.56353 6.97414 3.82874 6.97414C4.09396 6.97414 4.34831 7.0795 4.53585 7.26704L6.65717 9.38836L10.9182 5.12733C11.1057 4.93979 11.3601 4.83444 11.6253 4.83444C11.8905 4.83444 12.1449 4.93979 12.3324 5.12733C12.5199 5.31487 12.6253 5.56922 12.6253 5.83444C12.6253 6.09965 12.5199 6.35401 12.3324 6.54154L7.36428 11.5097C7.17674 11.6972 6.92239 11.8026 6.65717 11.8026C6.39195 11.8026 6.1376 11.6972 5.95006 11.5097Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/hpc_checkbox_seleted.svg
// module id = NSSC
// module chunks = 87